module.exports = __webpack_public_path__ + "img/tutorial1_2.de563c34.png";